import React, { useContext, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import AppContext from "~/presentation/AppContext";
import { useTokenCheck } from "~/presentation/hooks/useTokenCheck";
import { useDialog } from "~/presentation/providers/DialogProvider";
import LoginBox from "~/presentation/components/LoginBox";
import { useSessionCheck } from "../hooks/useCheckSession";

const PrivateRoute = ({ children }) => {
  const { setUser, isLogged } = useContext(AppContext);
  const { currentUser, isTokenValid } = useTokenCheck();
  const { openLoginDialog, closeLoginDialog } = useDialog();
  const navigate = useNavigate();

  const handleStorageChange = (event) => {
    if (event.key === "GT_token" || (event.type === "storage" && event.newValue === null)) {
      //window.location.reload(); // Reload the app to update the PrivateRoute component
    }
  };

  useEffect(() => {
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    const localStorageUser = localStorage.getItem("GT_user");
    setUser({ ...currentUser, ...JSON.parse(localStorageUser) });
  }, []);

  const handleLogin = () => {
    openLoginDialog({
      disableScrollLock: true,
      blockScreen: true,
      customComponent: () => (
        <LoginBox handleClose={closeLoginDialog} navigate={navigate} isReLogin />
      ),
    });
  };

  const isUserLogged = isLogged();

  // Se o usuário está logado, mas o token não é válido, abre o diálogo de re-login
  if (isUserLogged && currentUser && !isTokenValid) {
    handleLogin();
  }

  useSessionCheck(isUserLogged && currentUser && isTokenValid);

  // Se não tem user logado, redireciona para a página inicial
  if (!currentUser) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute;
